<template>
  <h3 :class="typeTextColor"><slot /></h3>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-modal-title>Modal Title</ak-modal-title>
   */

  name: 'AkModalTitle',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {String}
     * @description
     */
    color: {
      type: String,
      default: 'primary',
      validator: (value) => {
        return ['primary', 'danger', 'warning', 'success'].indexOf(value) >= 0
      },
    },
  },

  /**
   * @param {Object} props - The properties of the component
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props) {
    /**
     * @return {String}
     * @description Returns the text color to display
     */
    const typeTextColor = computed(() => {
      switch (props.color) {
        case 'danger':
          return 'color-danger'
        case 'success':
          return 'color-success'
        case 'warning':
          return 'color-warning'
        default:
          return 'color-primary'
      }
    })

    return {
      typeTextColor,
    }
  },
})
</script>
